import { useMemo } from 'react';

import { VaultColors } from '@/components/vaults/createBackupVaultPanel';
import { useDAL } from '@/contexts/useDAL';
import { stringToHash } from '@/utils/string';

import type { BackupVault } from './backupVault';

import { PreferencesKey } from '../dal/preferencesKey';

function useBackupVaults(): {
  vaults: BackupVault[];
  isLoading: boolean;
  refresh: () => void;
} {
  const dal = useDAL();
  const {
    isLoading: vaultsLoading,
    data: vaultsData,
    mutate,
  } = dal.vaults.list();

  const {
    data: pref,
    isLoading: prefLoading,
    isValidating: prefValidating,
    mutate: mutatePref,
  } = dal.preferences.getAccountPref(PreferencesKey.BackupVault);

  const refresh = () => void Promise.all([mutate(), mutatePref()]);

  const vaults = useMemo(
    () =>
      (vaultsData?.vaults || []).map((v) => {
        const userSetting = pref?.value?.colors?.find((p) => p.id === v.id);

        return {
          ...v,
          backgroundColor: userSetting?.color || getDeterministicColor(v.id),
        };
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pref?.value?.colors, vaultsData?.vaults, prefValidating]
  );

  return {
    vaults,
    isLoading: vaultsLoading || prefLoading,
    refresh,
  };
}

export default useBackupVaults;

function getDeterministicColor(id = 'yo'): string {
  return VaultColors[stringToHash(id, VaultColors.length)];
}
